export const NORMALISED_CARB_SWAP_SET = new Set(["carb swap", "carb swaps"]);
